import React from 'react';
import { useState } from 'react';
export const Uwinmainmodal = ({ onCloseUwinMainModal, onSelect }) => {
    const loggedinUserdetails = JSON.parse(localStorage.getItem("uwin_loggedinUserdetails")) || {};
    const isDPM = loggedinUserdetails.rolename === "Delivery Point Manager";
    const isAsha = loggedinUserdetails.rolename === "ASHA";
    return (

        <>
            <div className="modal fade show d-block verificationModel" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{ background: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0 ">
                            <div className="text-center headerText patientDetailsTitleHeader-h d-flex">
                                <span><img src="" alt="" className='pnmdp_icon' /></span>
                                <h5 className="modal-title" id="exampleModalLabel">U-WIN</h5>
                            </div>
                            <button type="button" className="btn-close" aria-label="Close" onClick={onCloseUwinMainModal} />

                        </div>
                        <div className="modal-body">
                            <div className="sickCellRow row">
                                <div className=" col-xs-12 col-md-4">
                                    <div className="sickCellCol" onClick={() => { onSelect('Add Beneficiary'); onCloseUwinMainModal() }}>
                                        <div className="circleImg">
                                            <span>
                                                <img src={"/images/Linkedchiled.svg"} alt='vaccination' />
                                            </span>
                                        </div>
                                        <div className="sickColTitle">   
                                            <h5>Add Beneficiary</h5>
                                        </div>
                                    </div>
                                </div>
                                {/* {(!isDPM && !isAsha) && ( 
                                )} */}
                                <div className=" col-xs-12 col-md-4">
                                    <div className="sickCellCol" onClick={() => { onSelect('Uwin Vaccination'); onCloseUwinMainModal() }}>
                                        <div className="circleImg">
                                            <span>
                                                <img src={"/images/Vaccination.svg"} alt='vaccination' />
                                            </span>
                                        </div>
                                        <div className="sickColTitle">
                                            <h5>Vaccination</h5>
                                        </div>
                                    </div>
                                </div>
                                {/* <div
                                    className="sickCellCol col-xs-12 col-md-4"
                                    style={{
                                        pointerEvents: 'none',
                                        opacity: 0.9,
                                        backgroundColor: '#f5f5f5',
                                    }}
                                >
                                    <div className="circleImg">
                                        <span>
                                            <img src={"/images/Pregnenet.svg"} alt='Pregnent Women' />
                                        </span>
                                    </div>
                                    <div className="sickColTitle">
                                        <h5>Pregnancy History</h5>
                                    </div>
                                </div> */}
                                {/* <div className=" col-xs-12 col-md-4" >
                                    <div className="sickCellCol " onClick={() => { onSelect('Linked Children'); onCloseUwinMainModal() }}>
                                        <div className="circleImg">
                                            <span>
                                                <img src={"/images/Linkedchiled.svg"} alt='"/images/Linkedchiled.svg" image' />
                                            </span>
                                        </div>
                                        <div className="sickColTitle">
                                            <h5>Linked Children</h5>
                                        </div>
                                    </div>
                                </div> */}
                                {/* <div className="sickCellCol invisible col-xs-12 col-md-4" onClick={() => { onSelect('Pateint List');  }}>
                            <div className="circleImg">
                                <span>
                                    <img src="" />
                                </span>
                            </div>
                            <div className="sickColTitle">
                                <h5>Patient List</h5>
                            </div>
                        </div> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}
